<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Jamie Rybeck is a first-time author who hails from Ireland, where he lives with his wife and three children. <em>Secret Sons</em> is an action-packed fiction novel that delves deep into the corporate world that Jamie has worked in for the past twenty years, transporting you to the four corners of the world.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?c3862d64